export type WalletConnector = {
  integration_type: 'pluggy';
  id: string;
  is_open_finance: boolean;
  name: string;
  thumb: string;
  color: string;
} & (
  | {
      active: true;
      connections?: Pick<
        WalletInstitutionConnection,
        'item_id' | 'checking_account_number'
      >[];
    }
  | {
      active: false;
      connections?: never;
    }
);

export type WalletSummary = {
  total: number;
  checking_account_total: number;
  investments_total: number;
};

export type WalletInstitution = {
  checking_account_total: number;
  color: string;
  connections: WalletInstitutionConnection[];
  connector_id: string;
  connector_name: string;
  currency: string;
  integration_type: string;
  investments_total: number;
  name: string;
  percentage: number;
  thumb: string;
  total: number;
};

export type WalletInstitutionWithInvestments = Omit<
  WalletInstitution,
  'connections'
> & {
  connnections: Omit<
    WalletInstitutionConnection,
    'checking_account_number' | 'item_id'
  >[];
  investments: WalletInvestment[];
};

export type WalletInstitutionConnection = {
  checking_account_number: string;
  checking_account_total: number;
  connector_id: string;
  connector_name: string;
  currency: string;
  integration_type: string;
  investments_total: number;
  item_id: string;
  total: number;
};

export type WalletInvestmentCategory = {
  color: string;
  name: string;
  percentage: number;
  total: number;
};

export type WalletInvestment = {
  category: string;
  connection: Pick<
    WalletInstitution,
    'connector_id' | 'connector_name' | 'integration_type'
  >;
  currency: string;
  name: string;
  percentage: number;
  strategy: string;
  subcategory: string;
  thumb: string;
  ticker: string;
  total: number;
};

export enum INVESTOR_PROFILES {
  Conservador = 15,
  Cauteloso = 25,
  Balanceado = 50,
  Arrojado = 75,
  Sofisticado = 100,
}

export type InvestorProfile = keyof typeof INVESTOR_PROFILES;

export type ConsolidatorOptimizerStatus = {
  consolidated: boolean;
  has_wallet_optimized: boolean;
  last_show_wallet_optimizer_at: string;
  show_wallet_optimizer: boolean;
};

export type WalletOptimizer = {
  allocation: WalletOptimizerAllocation[];
  suggested_move: WalletOptimizerSuggestedMove[];
  correct_allocation: WalletOptimizerCorrectAllocation[];
};

export type WalletOptimizerAllocation = {
  name: string;
  status: 'above' | 'within' | 'below';
  suggested: AllocationValues;
  my_wallet: AllocationValues;
};

type AllocationValues = {
  value: number;
  percentage: number;
};

export type WalletOptimizerSuggestedMove = {
  status: 'above' | 'within' | 'below';
  text_html: string;
};

export type WalletOptimizerCorrectAllocation = {
  text_html: string;
};
